import { createFileRoute, notFound } from "@tanstack/react-router"

import { logger } from "@repo/utils/logger"
import { getExtendedBusinessEntitiesQueryOptions } from "~/modules/business-entities/business-entities.queries"
import {
  BUSINESS_ENTITY_SYSTEM_ROLE_ID,
  CLIENT_SYSTEM_ROLE_ID,
  INTERNAL_SYSTEM_ROLE_ID,
  RESOURCE_SYSTEM_ROLE_ID,
  SUPER_ADMIN_ROLE_ID,
} from "~/modules/roles-and-permissions/constants"
import { ClientDashboard } from "./client-dashboard"
import { EmployeeDashboard } from "./employee-dashboard"
import { ResourceDashboard } from "./resource-dashboard"

const log = logger.child({
  module: "dashboard-route",
})

export const Route = createFileRoute("/_protected-layout/_os-layout/dashboard")(
  {
    component: RouteComponent,
    loader: async ({ context }) => {
      if (!context.appRole) {
        throw notFound()
      }

      context.queryClient
        .ensureQueryData(getExtendedBusinessEntitiesQueryOptions())
        .catch((error) => {
          log.error("Error getting extended business entities", { error })
          return null
        })

      return {
        appRole: context.appRole,
      }
    },
  },
)

function RouteComponent() {
  const { appRole } = Route.useLoaderData()

  switch (appRole.id) {
    case RESOURCE_SYSTEM_ROLE_ID:
      return <ResourceDashboard />
    case SUPER_ADMIN_ROLE_ID:
    case INTERNAL_SYSTEM_ROLE_ID:
    case BUSINESS_ENTITY_SYSTEM_ROLE_ID:
      return <EmployeeDashboard />
    case CLIENT_SYSTEM_ROLE_ID:
      return <ClientDashboard />
    default:
      throw notFound()
  }
}
